var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-container o-container--thin"},[_c('preloader-view',{staticClass:"o-v-rhythm--small"}),_vm._v(" "),_vm._l((_vm.cognitoSignOutURIs),function(src,index){return _c('img',{key:index,staticClass:"visually-hidden",attrs:{"src":src}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }